class MenuOptionsFamilyController {

  constructor($scope, EventEmitter) {
    'ngInject';
    this.scope = $scope;
    this.EventEmitter = EventEmitter;
  }

  $onInit() {
    this.onChange();
  }

  onChange() {
    this.scope.$watch(() => this.optionFamilySelected, newValue => {
      this.purposeCode = newValue;
    });
  }

  createCodeSimulation({ data }) {
    let codeSimulation = `${data.purposesCode}${data.familyCode}`;
    const dataSentEvent = {
      codeLoanSimulation: codeSimulation,
      codeOptionSelected: data.purposesCode,
    };
    this.onSelectOptionFamily(this.EventEmitter(dataSentEvent));
  }

}

export default MenuOptionsFamilyController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/needALoan/menuFamilyNeedALoan/menuOptionsFamily/menuOptionsFamily.controller.js